import { type ThemeOptions } from "@mui/material";

export const muiRebrandThemeTypography: ThemeOptions["typography"] = (palette) => ({
  allVariants: {
    fontFamily:
      '"Lato", "SF Pro", -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Roboto", sans-serif',
    color: palette.text.primary,
    fontWeight: 400,
    lineHeight: "inherit",
  },
  h1: {
    fontFamily:
      "Lora, 'SF Pro', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Roboto', serif",
    fontSize: "3rem", // 48px
    fontWeight: 400,
    lineHeight: 1.1667, // 56px
    letterSpacing: "-0.12rem", // -1.92px (-4%)
  },
  h2: {
    fontFamily:
      "Lora, 'SF Pro', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Roboto', serif",
    fontSize: "2.5rem", // 40px
    fontWeight: 400,
    lineHeight: 1.2, // 48px
    letterSpacing: "-0.05rem", // -0.8px (-2%)
  },
  h3: {
    fontFamily:
      "Lora, 'SF Pro', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Roboto', serif",
    fontSize: "2rem", // 32px
    fontWeight: 400,
    lineHeight: 1.125, // 36px
    letterSpacing: "-0.02rem", // -0.32px (-1%)
  },
  h4: {
    fontSize: "1.5rem", // 24px
    fontWeight: 700,
    lineHeight: 1.21, // 29px
    letterSpacing: "-0.015rem", // -0.24px
  },
  h5: {
    fontSize: "1.25rem", // 20px
    fontWeight: 500,
    lineHeight: 1.2, // 24px
    letterSpacing: "-0.0125rem", // -0.2px
  },
  h6: {
    fontSize: "1.125rem", // 18px
    fontWeight: 500,
    lineHeight: 1.1111, // 20px
    letterSpacing: "-0.01125rem", // -0.18px
  },

  body1: {
    fontSize: "1rem", // 16px
    lineHeight: 1.25, // 20px
    letterSpacing: 0, // 0%
  },
  body2: {
    fontSize: "0.875rem", // 14px
    lineHeight: 1.2857, // 18px
    letterSpacing: 0, // 0%
  },
  caption: {
    fontSize: "0.75rem", // 12px
    lineHeight: 1.1667, // 14px
    letterSpacing: "0.0225rem", // +0.36px (+3%)
  },
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
});
